// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-application .text-h4{font-family:Open Sans,Sans-Serif!important}", ""]);
// Exports
module.exports = exports;
